import React from "react";
import { FiAlertTriangle } from "react-icons/fi";

// how many of the model's 19 inputs were missing and got the training
// median (missing_features_imputed); from WARN_AT on, the result leans
// mostly on typical values rather than this woreda's own data
const TOTAL_INPUTS = 19;
const WARN_AT = 4;

export default function ImputedNote({ count, short = false }) {
  if (count === null || count === undefined || Number.isNaN(Number(count))) {
    return <span className="imputed-note">—</span>;
  }
  const n = Number(count);
  const warn = n >= WARN_AT;
  const title = `${n} of ${TOTAL_INPUTS} model inputs were missing and filled with typical (training median) values`;
  const label = short
    ? `${n} filled`
    : n === 0
      ? "All inputs measured"
      : `${n} input${n === 1 ? " was" : "s were"} filled with typical values`;

  return (
    <span className={`imputed-note ${warn ? "imputed-note--warn" : ""}`} title={title}>
      {warn && <FiAlertTriangle />}
      {label}
    </span>
  );
}
